module.exports = __webpack_public_path__ + "static/media/login_wallpaper.6e78be19.png";